import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { BrandService } from "../../../Services/brand.service";
import { CategoryService } from "../../../Services/category.service";
import { Category } from "../../../Models/category";
import { Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

enum FilterItemType {
  "price",
  "category",
  "brand",
  "keyword",
}

@Component({
    selector: "app-applied-filter",
    templateUrl: "./applied-filter.component.html",
    styleUrls: ["./applied-filter.component.scss"],
    standalone: false
})
export class AppliedFilterComponent implements OnInit {
  // filterItems = [];
  filterItems: { id?: number; type: FilterItemType; value: string }[] = [];

  minPrice: number | null = null;
  maxPrice: number | null = null;
  brands: any;
  listCategories: number[] | null = null;

  selectedSubCategoryId?: number;
  query: string | null = "";
  categories?: Observable<Category[]>;
  idsBrand: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private brandService: BrandService,
    private categoryService: CategoryService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.getActivatedRoute().data.subscribe((filter) => {
      this.changeFilterItems();
    });
  }

  changeFilterItems() {
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      this.filterItems = [];
      this.brands = null;

      if (params.has("query")) {
        this.query = params.get("query");
        this.filterItems.push({
          type: FilterItemType.keyword,
          value: this.translate.instant("globalUi.filter.keyword", { query: this.query }),
        });
      }

      if (params.has("minPrice")) {
        this.minPrice = Number(params.get("minPrice"));
        this.maxPrice = Number(params.get("maxPrice"));
        this.filterItems.push({
          type: FilterItemType.price,
          value: this.translate.instant("globalUi.filter.priceRange", {
            min: this.minPrice,
            max: this.maxPrice,
          }),
        });
      }

      if (params.has("categories")) {
        this.listCategories = [];
        const idsSubCat = params.getAll("categories");
        idsSubCat.forEach((idSubCat) => {
          this.listCategories?.push(Number(idSubCat));
          this.categoryService.getById(Number(idSubCat)).subscribe((e) => {
            const subSubCategories = "[Categorie] " + e!.label;
            this.filterItems.push({
              type: FilterItemType.category,
              value: subSubCategories,
            });
          });
        });
      }

      if (params.has("brands")) {
        this.brands = [];
        this.idsBrand = params.getAll("brands");
        this.idsBrand.forEach((idBrand: any) => {
          this.brands?.push(Number(idBrand));
          this.brandService.getById(Number(idBrand)).subscribe((e) => {
            const brand = "[Marque] " + e!.name;
            this.filterItems.push({
              type: FilterItemType.brand,
              value: brand,
            });
            // console.log(this.brands)
          });
        });
      }
      if (params.has("minPrice")) {
        this.query = params.get("query");
      }
    });
  }
  clearAll() {
    this.filterItems = [];
    this.router.navigate([], {
      queryParams: null,
    });
  }

  clearItem(index: number) {
    switch (this.filterItems[index].type) {
      case FilterItemType.keyword:
        this.query = null;
        this.filterItems.splice(index, 1);
        this.router.navigate([], {
          queryParams: { query: null },
          queryParamsHandling: "merge",
        });
        break;

      case FilterItemType.price:
        this.maxPrice = null;
        this.minPrice = 0;
        this.filterItems.splice(index, 1); // we can remove it bcz update % route params
        this.router.navigate([], {
          queryParams: { minPrice: null, maxPrice: null },
          queryParamsHandling: "merge",
        });
        break;

      case FilterItemType.category:
        this.listCategories = this.listCategories!.filter(
          (c) => c !== this.filterItems[index].id
        );
        this.listCategories.splice(index, 1);
        this.router.navigate([], {
          queryParams: { categories: this.listCategories },
          queryParamsHandling: "merge",
        });
        break;
      case FilterItemType.brand:
        this.brands = this.brands.filter(
          (m: any) => m !== this.filterItems[index].id
        );
        this.brands.splice(index, 1);
        this.router.navigate([], {
          relativeTo: this.getActivatedRoute(),
          queryParams: {
            minPrice: this.minPrice,
            maxPrice: this.maxPrice,
            brands: this.brands,
          },
          queryParamsHandling: "merge",
        });
        break;
    }
  }
  getActivatedRoute(): ActivatedRoute {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
